import Vue from 'vue';
import Vuex from 'vuex';
import { createStore } from 'vuex-smart-module';
import { Getters, Mutations, Actions, Module } from 'vuex-smart-module';
import { UiStore } from '@/services/store/modules/ui/store';
import { DataStore } from '@/services/store/modules/data/store';
Vue.use(Vuex);
class RootState {
}
class RootGetters extends Getters {
}
class RootMutations extends Mutations {
}
class RootActions extends Actions {
}
const store = createStore(new Module({
    namespaced: true,
    state: RootState,
    getters: RootGetters,
    mutations: RootMutations,
    actions: RootActions,
    modules: {
        UiStore,
        DataStore
    }
}), {
    strict: process.env.NODE_ENV !== 'production'
});
export default store;
